"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Facebook, Twitter, Instagram, Linkedin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex gap-6">
        <div className="h-4 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted/30 animate-pulse rounded" />
        <div className="h-4 w-16 bg-muted/30 animate-pulse rounded" />
      </div>;
  }
  return <nav className="flex gap-6">
      {menuItems.map(item => <Link key={item.id} to={item.href || "#"} className="text-sm text-muted-foreground hover:text-foreground transition-all duration-fast hover:opacity-100 opacity-70">
          {item.label}
        </Link>)}
    </nav>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer id="footer" className="bg-background border-t border-muted/20 py-8">
      <div className="container mx-auto px-4 max-w-7xl">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8">
          {}
          <div className="flex-shrink-0">
            <Link to="/">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542868/img/visit_france_4_less_logo.png" alt="Visit-France-4-Less" className="h-7" />
            </Link>
          </div>

          {}
          <div className="flex items-center gap-4">
            <Link to="https://facebook.com" newTab className="text-muted-foreground hover:text-foreground transition-all duration-fast hover:opacity-100 opacity-70" aria-label="Facebook">
              <Facebook className="size-5" />
            </Link>
            <Link to="https://twitter.com" newTab className="text-muted-foreground hover:text-foreground transition-all duration-fast hover:opacity-100 opacity-70" aria-label="Twitter">
              <Twitter className="size-5" />
            </Link>
            <Link to="https://instagram.com" newTab className="text-muted-foreground hover:text-foreground transition-all duration-fast hover:opacity-100 opacity-70" aria-label="Instagram">
              <Instagram className="size-5" />
            </Link>
            <Link to="https://linkedin.com" newTab className="text-muted-foreground hover:text-foreground transition-all duration-fast hover:opacity-100 opacity-70" aria-label="LinkedIn">
              <Linkedin className="size-5" />
            </Link>
          </div>

          {}
          <MenuProvider menu_id="52">
            <FooterMenuConsumer />
          </MenuProvider>
        </div>

        {}
        <div className="mt-6 pt-6 border-t border-muted/20 text-center">
          <p className="text-sm text-muted-foreground">
            © 2026 Visit-France-4-Less. All rights reserved. Managed by French Incoming.
          </p>
        </div>
      </div>
    </footer>;
}